import { Component, EventEmitter, OnInit, Output, ViewContainerRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { forkJoin, Observable, timer } from 'rxjs';
import { DialogService } from '../../../_services/dialog.service';
import { PledgePerWinSubscriber } from '../../../_models/fundraising/ppw/PledgePerWinSubscriber';
import { Subscriber } from '../../../_models/fundraising/ppw/Subscriber';
import { PledgePerWinService } from '../../../_services/fundraising/pledgePerWin.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    templateUrl: './ppw-cancel-reverse-modal.component.html',
    styleUrls: ['./ppw-cancel-reverse-modal.component.css']
  })

export class PledgePerWinCancelModalComponent implements OnInit {

    public cancelling: boolean;
    public reversing: boolean;

    public subscriber: Subscriber;

    public selectedSubscriptions: PledgePerWinSubscriber[] = [];
    public subscriptions: PledgePerWinSubscriber[] = [];

    public viewRef: ViewContainerRef;

    @Output() submitted = new EventEmitter;

    constructor(
        private ppwService: PledgePerWinService,
        private bsModalRef: BsModalRef,
        private dialogService: DialogService,
        private spinner: NgxSpinnerService,
    ){}

    ngOnInit () {

        this.subscriptions = this.subscriber.subscriptions.filter(sub => !sub.cancelled);
    }

    onSelectSubscription (subscription: PledgePerWinSubscriber) {
        if (this.selectedSubscriptions.includes(subscription)){
            const idx = this.selectedSubscriptions.indexOf(subscription);
            this.selectedSubscriptions.splice(idx, 1);
        } else {
            this.selectedSubscriptions.push(subscription);
        }
    }

    reverseAndClose () {

        this.spinner.show();

        this.ppwService.reverseSubscriberCharges(this.subscriber.pledgePerWinSubscriberId, this.selectedSubscriptions)
            .subscribe(
                _ => {
                    this.spinner.hide();
                    this.close();

                    this.dialogService.alert("Success", "Charges have been successfully reversed.", this.viewRef);
                },
                error => {
                    this.spinner.hide();
                    this.close();

                    this.dialogService.alert("Oops something went wrong...", 
                                            "We were unable to process your request at this time, please try again in a few moments. Please contact CUE support at support@connectwithcue.com if you continue to experience issues", 
                                            this.viewRef);
                });
    }

    cancelAndClose () {

        this.spinner.show();

        this.ppwService.cancelSubscriberSubscriptions(this.subscriber.pledgePerWinSubscriberId, this.selectedSubscriptions)
            .subscribe(
                _ => {
                    this.spinner.hide();
                    this.close();

                    this.dialogService.alert("Success", "Those subscriptions have been cancelled.", this.viewRef);
                },
                error => {
                    this.spinner.hide();
                    this.close();

                    this.dialogService.alert("Oops something went wrong...", 
                                            "We were unable to process your request at this time, please try again in a few moments. Please contact CUE support at support@connectwithcue.com if you continue to experience issues", 
                                            this.viewRef);
                });
    }

    close () {
        
        this.bsModalRef.hide();
    }
}